import {AfterViewInit, Directive, ElementRef, NgZone, OnDestroy} from "@angular/core";

@Directive({
	standalone: true,
	selector: "[appAutocompleteRight]",
})
export class AutocompleteRightDirective implements AfterViewInit, OnDestroy {
	private observer: MutationObserver;

	constructor(
		private el: ElementRef<HTMLInputElement>,
		private zone: NgZone,
	) {}

	ngAfterViewInit(): void {
		const input = this.el.nativeElement;

		const applyPanelStyle = () => {
			this.zone.runOutsideAngular(() => {
				setTimeout(() => {
					const panel = document.querySelector(".mat-mdc-autocomplete-panel") as HTMLElement;
					if (panel && input) {
						panel.style.position = "absolute";
						panel.style.transform = "translateX(40%)";
						panel.style.zIndex = "1000";
						panel.style.width = "max-content";
						panel.style.maxWidth = "75rem";
						panel.style.maxHeight = "30rem";
					}
				});
			});
		};

		this.observer = new MutationObserver(applyPanelStyle);
		this.observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		["focus", "click", "input"].forEach((event) => input.addEventListener(event, applyPanelStyle));

		window.addEventListener("resize", applyPanelStyle);
		window.addEventListener("scroll", applyPanelStyle);
	}

	ngOnDestroy(): void {
		this.observer.disconnect();
		window.removeEventListener("resize", () => {});
		window.removeEventListener("scroll", () => {});
	}
}
